import React, { useState } from 'react';
import axios from 'axios';
import { Prod01 } from '../../constants/ActionType';
import { DEVICE_TYPES, errorText } from '../../utils/deviceAssign';

const orgLabel = (patient) => patient?.organizationId?.name || patient?.organizationName || "This patient's organization";

/**
 * Inline "Register & assign" for an IMEI that is not in inventory: the device is created in the patient's
 * organization (server-enforced) and attached to the patient in one request.
 */
const RegisterDeviceForm = ({ imei, patient, onDone, onCancel }) => {
    const [form, setForm] = useState({ deviceType: 'bp', code: imei || '', deviceId: '', modelNumber: '' });
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
    const invalid = !form.deviceType || !/^\d{15}$/.test(form.code.trim()) || form.deviceId.trim().length < 4;

    const submit = async (e) => {
        if (e) e.preventDefault();
        if (invalid || busy || !patient?._id) return;
        setBusy(true);
        setErr('');
        try {
            await axios.post(`${Prod01}/inventory/register-assign`, {
                code: form.code.trim(), deviceId: form.deviceId.trim(), deviceType: form.deviceType,
                ...(form.modelNumber.trim() ? { modelNumber: form.modelNumber.trim() } : {}), patientId: patient._id,
            });
            onDone(`Device …${form.code.trim().slice(-5)} registered and assigned to ${[patient.firstname, patient.lastname].filter(Boolean).join(' ')}.`);
        } catch (e2) {
            setErr(errorText(e2));
        }
        setBusy(false);
    };

    return (
        <form onSubmit={submit} data-testid="register-device-form">
            <p className="mb-2" style={{ fontSize: 13 }}>IMEI not found in inventory. Register it and assign it to this patient:</p>
            <label htmlFor="rd-type" className="mb-0">Device type</label>
            <select id="rd-type" className="form-control form-control-sm mb-2" value={form.deviceType} onChange={set('deviceType')}>
                {DEVICE_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
            <label htmlFor="rd-imei" className="mb-0">IMEI</label>
            <input id="rd-imei" className="form-control form-control-sm mb-2" inputMode="numeric" autoComplete="off" value={form.code} onChange={set('code')} />
            <label htmlFor="rd-id" className="mb-0">Device ID <small className="text-muted">(on the device label; readings are matched by it)</small></label>
            <input id="rd-id" className="form-control form-control-sm mb-2" autoComplete="off" value={form.deviceId} onChange={set('deviceId')} autoFocus />
            <label htmlFor="rd-model" className="mb-0">Model <small className="text-muted">(optional)</small></label>
            <input id="rd-model" className="form-control form-control-sm mb-2" autoComplete="off" value={form.modelNumber} onChange={set('modelNumber')} />
            <label htmlFor="rd-org" className="mb-0">Organization</label>
            <input id="rd-org" className="form-control form-control-sm mb-2" value={orgLabel(patient)} readOnly disabled />
            {err ? <div className="alert alert-danger py-1 mb-2" role="alert" style={{ fontSize: 13 }}>{err}</div> : null}
            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
                <button type="button" className="btn btn-secondary btn-sm" disabled={busy} onClick={onCancel}>Cancel</button>
                <button type="submit" className="btn btn-primary btn-sm" disabled={busy || invalid}>{busy ? 'Saving…' : 'Register & assign'}</button>
            </div>
        </form>
    );
};

export default RegisterDeviceForm;
